import { getCreditLevelConfig } from "@/apis/common";
import { getCreditInfo } from "@/apis/user";
import { StateReducer, useCreateReducer } from "@/libs/reducer";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { useLockFn, useMount, useSetState } from "ahooks";
import { Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";
/**
 * 使用 Turn Interface to Object 插件去直接成 pagestate
 */
interface PageState {}

const pagestate = {};

type ActionType = "update-hello";

const stateReducer: StateReducer<PageState, ActionType> = (state, action) => {
  switch (action.type) {
    case "update-hello":
      return Object.assign({}, state, {});

    default:
      return state;
  }
};

export const useSetup = () => {
  const navigate = useNavigate();
  const { user } = useUserAuthContext();
  const [state, dispatch] = useCreateReducer<PageState, ActionType>(
    stateReducer,
    pagestate,
    {},
  );
  const [creditInfo, setCreditInfo] = useSetState({
    creditLevel: {
      creditLevelId: 1,
      icon: "",
      level: 1,
      name: "信用1级",
      upgradeScore: 0,
    },
    currentScore: 0,
    diffScore: 0,
    nextUpgradeScore: 10000,
  });
  const [levelConfig, setLevelConfig] = useSetState({
    list: [
      {
        label: "1分~1999分",
        level: 1,
        grade: 1,
      },
      {
        label: "2000分~3999分",
        level: 2,
        grade: 1,
      },
      {
        label: "4000分~5999分",
        level: 3,
        grade: 1,
      },
      {
        label: "6000分~7999分",
        level: 4,
        grade: 1,
      },
      {
        label: "8000分~9999分",
        level: 5,
        grade: 1,
      },

      {
        label: "10000分~19999分",
        level: 1,
        grade: 2,
      },
      {
        label: "20000分~29999分",
        level: 2,
        grade: 2,
      },
      {
        label: "30000分~39999分",
        level: 3,
        grade: 2,
      },
      {
        label: "40000分~49999分",
        level: 4,
        grade: 2,
      },
      {
        label: "50000分~59999分",
        level: 5,
        grade: 2,
      },
      {
        label: "60000分~79999分",
        level: 1,
        grade: 3,
      },
      {
        label: "80000分~99999分",
        level: 2,
        grade: 3,
      },
      {
        label: "100000分~119999分",
        level: 3,
        grade: 3,
      },
      {
        label: "120000分~139999分",
        level: 4,
        grade: 3,
      },
      {
        label: "140000分~159999分",
        level: 5,
        grade: 3,
      },
      {
        label: "160000分~189999分",
        level: 1,
        grade: 4,
      },
      {
        label: "190000分~219999分",
        level: 2,
        grade: 4,
      },
      {
        label: "220000分~249999分",
        level: 3,
        grade: 4,
      },
      {
        label: "250000分~279999分",
        level: 4,
        grade: 4,
      },
      {
        label: "280000分~309999分",
        level: 5,
        grade: 4,
      },
      {
        label: "310000分~379999分",
        level: 1,
        grade: 5,
      },
      {
        label: "380000分~409999分",
        level: 2,
        grade: 5,
      },
      {
        label: "420000分~459999分",
        level: 3,
        grade: 5,
      },
      {
        label: "460000分~499999分",
        level: 4,
        grade: 5,
      },
      {
        label: "500000分以上",
        level: 5,
        grade: 5,
      },
    ],
  });

  const credit = useLockFn(async () => {
    const response = await getCreditInfo({});
    if (response.ok) {
      setCreditInfo(response.data!);
    } else {
      Toast.show(response.msg);
    }
  });

  const level = useLockFn(async () => {
    const response = await getCreditLevelConfig({});
    if (response.ok) {
      setLevelConfig((config) => {
        return {
          list: config.list.map((item, index) => {
            const current = response.data![index];
            const next = response.data![index + 1];
            if (next) {
              item.label = `${current.upgradeScore}分~${next.upgradeScore}分`;
            } else {
              item.label = `${current.upgradeScore}分以上`;
            }
            return item;
          }),
        };
      });
    } else {
      Toast.show(response.msg);
    }
  });

  useMount(() => {
    credit();
    level();
  });

  return { state, dispatch, navigate, user, creditInfo, levelConfig };
};
